import { useState } from 'react';

import { validateNewPassword } from '@/utils/password';

type PinStatus = 'error' | 'success' | undefined;

/* Estado y validación de "nueva clave" + "repite la clave" (cambio y reseteo de clave).
`previousPassword` solo lo pasa el cambio obligatorio, para impedir reutilizarla */
export default function useNewPassword(previousPassword?: string | null) {
  const [newPassword, setNewPassword] = useState<string>('');
  const [repeatedPassword, setRepeatedPassword] = useState<string>('');

  // Se recalcula en cada render: al corregir un dígito la validación se actualiza al momento
  const { isValid, errorMessage } = validateNewPassword(
    newPassword,
    repeatedPassword,
    previousPassword,
  );

  // Con cualquier error se marcan en rojo los dos grupos de casillas
  const status: PinStatus = errorMessage ? 'error' : isValid ? 'success' : undefined;

  const reset = () => {
    setNewPassword('');
    setRepeatedPassword('');
  };

  return {
    newPassword,
    setNewPassword,
    repeatedPassword,
    setRepeatedPassword,
    isValid,
    errorMessage,
    newPasswordStatus: status,
    repeatedPasswordStatus: status,
    reset,
  };
}
